import { FC, SVGProps } from 'react';

export const DragIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width='9' height='16' viewBox='0 0 9 16' fill='none' {...props}>
		<ellipse cx='2.08301' cy='13.8333' rx='1.25' ry='1.25' transform='rotate(-90 2.08301 13.8333)' fill='currentColor' />
		<ellipse cx='2.08301' cy='8' rx='1.25' ry='1.25' transform='rotate(-90 2.08301 8)' fill='currentColor' />
		<ellipse cx='2.08301' cy='2.16663' rx='1.25' ry='1.25' transform='rotate(-90 2.08301 2.16663)' fill='currentColor' />
		<ellipse cx='7.5' cy='13.8333' rx='1.25' ry='1.25' transform='rotate(-90 7.5 13.8333)' fill='currentColor' />
		<ellipse cx='7.5' cy='8' rx='1.25' ry='1.25' transform='rotate(-90 7.5 8)' fill='currentColor' />
		<ellipse cx='7.5' cy='2.16663' rx='1.25' ry='1.25' transform='rotate(-90 7.5 2.16663)' fill='currentColor' />
	</svg>
);
